import React, { Component } from 'react'
import {Row, Col} from 'reactstrap'
import checkMarkSVG from '../../../assets/images/icons/checkmark.svg';
import cuttingContour from '../../../assets/images/icons/cutting-contour.svg';
import cuttingRectangular from '../../../assets/images/icons/cutting-rectangular.svg';
import cuttingExtempted from '../../../assets/images/icons/cutting-extempted.svg';
import PropTypes from "prop-types";
import { UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import {FaExclamationTriangle } from 'react-icons/fa';

const vectorTypes = ['svg', 'ai', 'eps', 'pdf']
class CuttingField extends Component {

  renderPopoverContent(key) {
    if (key === 'rectangular') {
      return this.context.t('Cutting.Rectangular.Popover')
    } else if (key === 'outline'){
      return this.context.t('Cutting.Outline.Popover')
    } else if (key === 'exempted'){
      return this.context.t('Cutting.Exempted.Popover')
    }
  }

  renderCuttingDescription(key) {
    if (key === 'rectangular') {
      return this.context.t('Cutting.Rectangular.Description')
    } else if (key === 'outline'){
      return this.context.t('Cutting.Outline.Description')
    } else if (key === 'exempted'){
      return this.context.t('Cutting.Exempted.Description')
    }
  }

  renderCuttingImg(key) {
    if (key === 'rectangular') {
      return cuttingRectangular
    } else if (key === 'outline'){
      return cuttingContour
    } else if (key === 'exempted'){
      return cuttingExtempted
    } else {
      return 'https://cdn.myfolie.de/media/20x20.png'
    }
  }

  renderFileTypeWarning(key) {
    if (key === 'rectangular') return '';
    else {
      const {file, vectorizeFile} = this.props;
      if (!vectorizeFile && file && file.uploadedFile && file.uploadedFile.filetype){
        if(!vectorTypes.includes(file.uploadedFile.filetype)){
          return (<FaExclamationTriangle className="text-warning" aria-hidden="true" />)
        }
      } else return ''
    }
    
  }

  render() {
    const {
      input: { value, onChange },
      cuttings,
      itemsClassName,
    } = this.props
    
    const _itemsClassName = itemsClassName ? (' ' + itemsClassName) : '';
    return (
      <div>
          { cuttings.map((availableCutting, index) => {
            const isChecked = (availableCutting.key === value);

            return (
              <div key={`cutting_${index}`}>
                <Row
                  className={'cutting-field-label' + _itemsClassName + (isChecked ? ' checked' : '')}
                  htmlFor={ availableCutting.key }
                  onClick={() => onChange(availableCutting.key)}
                  id={`cutting_${index}_id`}
                  >
                    <Col
                      xs={4}
                      className={"cutting-field-icon-container"}
                    >
                      <img
                        src={ this.renderCuttingImg(availableCutting.key)}
                        className={ 'cutting-field-icon'}
                        alt={ 'cutting-field-icon'}
                        loading="lazy"
                      />
                      { isChecked &&
                        <img
                          src={checkMarkSVG}
                          className="cutting-field-checkmark"
                          alt="selected cutting"
                          loading="lazy"
                        />
                      }
                    </Col>
                    <Col xs={8} className="cutting-field-details">
                      <div className="cutting-field-details-title">
                        <strong>
                          {this.context.t(availableCutting.key)}
                          {this.renderFileTypeWarning(availableCutting.key)}
                        </strong>
                      </div>
                      <div className="cutting-field-details-subtitle">
                        <small>
                          { this.renderCuttingDescription(availableCutting.key) }
                        </small>
                        <span className="text-remark" id={`cutting_${index}_id_details`}> { this.context.t('Details') }</span>
                      </div>
                    </Col>
                </Row>
                <UncontrolledPopover trigger="hover" delay={{ show: 0, hide: 0 }} placement="right" target={`cutting_${index}_id_details`}>
                  <PopoverHeader>{this.context.t(availableCutting.key)}</PopoverHeader>
                  <PopoverBody><div dangerouslySetInnerHTML={{__html: this.renderPopoverContent(availableCutting.key) }} /></PopoverBody>
                </UncontrolledPopover>
              </div>
            );
          })}
      </div>
    )
  }
}

/**  define proptype for the 'translation' function  */
CuttingField.contextTypes = {
  t: PropTypes.func
}

export default CuttingField;